module.exports = __webpack_public_path__ + "img/mac-icon4.48c8e44.png";